import React from 'react';
import { Field } from 'formik';
import { paymentOptions, hearAboutOptions } from '../../store';
import Section from '../form/Section';
import DropdownWithChange from '../form/DropdownWithChange';
import Dropdown from '../form/Dropdown';
import TextInput from '../form/TextInput';
import TextArea from '../form/TextArea';
import Acceptance from '../form/Acceptance';

const OrtherInformation = ({ values, setFieldValue }) => {
  const hearAboutHandler = (e) => {
    const val = e.target.value;

    if (val !== 'Others') {
      setFieldValue('hear_about_other', '');
    }

    setFieldValue('hear_about', val);
  };

  return (
    <Section>
      <div className='flex mb-2 flex-col md:flex-row'>
        <div className='w-full mr-0 md:w-1/2 md:mr-3'>
          <Field
            label='Payment Method'
            name='payment_method'
            required
            value={values.payment_method}
            options={paymentOptions}
            component={Dropdown}
          />
        </div>
        <div className='w-1/2 ml-3'></div>
      </div>
      {/* --- */}
      <div className='flex mb-2 flex-col md:flex-row'>
        <div className='w-full mr-0 md:w-1/2 md:mr-3'>
          <Field
            label='How did you hear about us?'
            name='hear_about'
            value={values.hear_about}
            required
            options={hearAboutOptions}
            component={DropdownWithChange}
            change={hearAboutHandler}
          />
          {values.hear_about === 'Others' && (
            <Field
              label='Please specify'
              name='hear_about_other'
              required
              component={TextInput}
            />
          )}
        </div>
        <div className='w-full ml-0 md:w-1/2 md:ml-3'>
          <Field
            label='Preferred Name on Name Tag'
            name='tag_preferred_name'
            value={values.tag_preferred_name}
            required
            component={TextInput}
          />
        </div>
      </div>
      <div className='mb-2'>
        <Field
          label='Remarks / Special Requests / Dietary Preference'
          name='remarks'
          value={values.remarks}
          component={TextArea}
        />
      </div>
      <div className='mb-2'>
        <Field required name='pdpa' value={values.pdpa} component={Acceptance}>
          <p className='mb-3'>
            I confirm that all information provided is accurate and complete and
            that I have read and accepted NUS Business School's terms and
            conditions and cancellation policy.
          </p>
          <p>
            I understand that my place is not secured, and I will not receive
            pre-course materials, or any required course equipment until payment
            or a purchase order is received and acknowledged by NUS.
          </p>
        </Field>
      </div>
    </Section>
  );
};

export default OrtherInformation;
